module.exports = __webpack_public_path__ + "static/media/whatsapp.5019da86.svg";